import { HTMLAttributes } from 'react';
import { cn } from '../../utils';
import { ComboboxOption } from './Combobox';

export type ComboboxItemOption = ComboboxOption;

export interface ComboboxItemProps
  extends HTMLAttributes<HTMLDivElement>,
    ComboboxItemOption {}

export const ComboboxItem = ({ label, ...props }: ComboboxItemProps) => (
  <div
    {...props}
    className={cn('text-medium flex items-center gap-2', props.className)}
  >
    <span className="text-primary leading-4.5 font-semibold">
      {label || ''}
    </span>
  </div>
);
